import TcalPartyCarrierCodeApiUrls from 'src/apiUrls/TcalPartyCarrierCodeApiUrls'
import FormProperties from './FormProperties'
import { Grid } from '@material-ui/core'
import React from 'react'
import { components } from 'cng-web-lib'
import pathMap from 'src/paths/PathMap_AccountSetup'

const {
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngAddForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          history={history}
          showNotification={showNotification}
          bodySection={
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
            />
          }
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: TcalPartyCarrierCodeApiUrls.POST,
            successRedirect: pathMap.TCAL_PARTY_CARRIER_CODE_LIST_VIEW
          }}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage
